module.exports = __webpack_public_path__ + "static/media/clasipro.85361cfe.png";